import React, { useContext } from 'react';
import { get, map, pick } from 'lodash';

import Dropdown from 'src/presentation/components/forms/Dropdown';
import FormContext from 'src/presentation/contexts/FormContext';

export default function RoutingGroupDropDown({ baseAttr, className, inboxes, inboxesMap }) {
  const attr = baseAttr ? `${baseAttr}.` : '';

  const { workingState } = useContext(FormContext);
  const currentRoutingGroup = inboxesMap[get(workingState, `${attr}routingGroupId`) as any];

  const placeholder = currentRoutingGroup?.disabled ? `${currentRoutingGroup.name} (deactivated)` : 'Select the Inbox';

  const inboxOptions = map(inboxes, inbox => pick(inbox, ['label', 'value']));

  return (
    <Dropdown
      attr={`${attr}routingGroupId`}
      className={className}
      data-aid={`${attr}routingGroupId`}
      options={inboxOptions}
      placeholder={placeholder}
      searchable
    />
  );
}
